export default __webpack_public_path__ + "static/favicon-196x196-d37e64f1199ce0b5d21f1212e91f65b7.png";